import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';

class dndStore {

    // Main Properties

    @observable dndItems = [];
    @observable dndPendingOrder = undefined;
    @observable dndRemark = '';

    // Dnd Confirm

    @observable dndTimeSelected = 'now';
    @observable dndTimeDeliver = '';
    @observable dndTimeDeliverDate = '';

    // Initialization

    @action initGetDnds() {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Dnds.apiGetDnds(languageCode).then((dndResponses) => {
            if (dndResponses) {
                that.dndItems = dndResponses.items;
            } else {
                that.dndItems = [];
            }
        });
    }

    @action refreshDnds() {
        const that = this;
        that.dndItems = [];

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.Dnds.apiGetDnds(languageCode).then((dndResponses) => {
            if (dndResponses) {
                that.dndItems = dndResponses.items;
            }
        });
    }

    @action initDndConfirm() {
        this.dndRemark = '';
        this.dndTimeSelected = 'now';
        this.dndTimeDeliver = '';

        this.dndPendingOrder = this.dndItems.find(dndItem => dndItem.isSelected === true);
        return this.dndPendingOrder;
    }

    // GET Properties

    @action getDndPendingOrder() {
        return this.dndItems.find(dndItem => dndItem.isSelected === true);;
    }

    // Set Properties

    @action setDndIsSelected(taskId, isSelected) {
        this.dndItems.map(dndItem => {
            return dndItem.isSelected = false;
        });

        const dndItem = this.dndItems.find(x => x.taskId === taskId);
        dndItem.isSelected = isSelected;
    }

    @action setDndRemark(value) {
        this.dndRemark = value;
    }

    @action setDndTimeSelected(value) {
        this.dndTimeSelected = value;
        this.dndTimeDeliver = '';
    }

    @action setDndTimeDeliver(value) {
        this.dndTimeDeliver = value;
        this.dndTimeSelected = '';
    }

    @action setDndTimeDeliverDate(value) {
        this.dndTimeDeliverDate = value;
    }

    // RESET Properties

    @action resetDnds() {
        this.dndItems = [];
    }
}

export default new dndStore()